import http from "./http-common";
import authHeader from "./auth-header";
import process from "shelljs";

const API_URL = process.env.BFF_URL;

class BusinessService {

  findAll(params, businessType) {
    const queryParams = { ...params };
    if (businessType) {
      queryParams.businessType = businessType;
    }
    return http.get(API_URL + `/v1/businesses`, { params: queryParams, headers: authHeader() })
  }

  create(mid, store) {
    return http.post(API_URL + `/stores`, store, { headers: authHeader() });
  }

  update(mid, id, store) {
    return http.put(API_URL + `/stores/${id}`, store, { headers: authHeader() });
  }

  findById(mid, id) {
    return http.get(API_URL + `/stores/${id}`, { headers: authHeader() });
  }

  delete(mid, id) {
    return http.delete(API_URL + `/stores/${id}`, { headers: authHeader() });
  }

  handleResponse(response) {
    return response
  }
}

export default new BusinessService();



// WEBPACK FOOTER //
// ./src/service/business.service.js